import { render } from "./CreditoSimpleGFComponent.vue?vue&type=template&id=0c6ef5e7"
import script from "./CreditoSimpleGFComponent.vue?vue&type=script&lang=js"
export * from "./CreditoSimpleGFComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__